var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgFlagOrgs = function SvgFlagOrgs(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 99 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 20.438S27.585 11 49 11s38 9.438 38 9.438-3.503 24.504-12.231 36.84C66.04 69.614 49 83 49 83S33.173 71.013 23.461 57.278C13.75 43.543 11 20.438 11 20.438z",
    fill: "#3FA9F5",
    filter: "url(#filter0_d_1201_2585)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52 30.222V26.2a2.2 2.2 0 0 0-2.2-2.2H34.2a2.2 2.2 0 0 0-2.2 2.2v27.6a2.2 2.2 0 0 0 2.2 2.2h31.6a2.2 2.2 0 0 0 2.2-2.2V32.422a2.2 2.2 0 0 0-2.2-2.2H52z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2 32.222a.2.2 0 0 1-.2-.2V26.2a.2.2 0 0 0-.2-.2H34.2a.2.2 0 0 0-.2.2v27.6c0 .11.09.2.2.2h31.6a.2.2 0 0 0 .2-.2V32.422a.2.2 0 0 0-.2-.2H50.2zM40.4 50.69a.2.2 0 0 1-.2.2h-2.8a.2.2 0 0 1-.2-.2v-2.711c0-.11.09-.2.2-.2h2.8c.11 0 .2.09.2.2v2.71zm0-6.222a.2.2 0 0 1-.2.2h-2.8a.2.2 0 0 1-.2-.2v-2.711c0-.11.09-.2.2-.2h2.8c.11 0 .2.09.2.2v2.71zm0-6.223a.2.2 0 0 1-.2.2h-2.8a.2.2 0 0 1-.2-.2v-2.71c0-.111.09-.2.2-.2h2.8c.11 0 .2.089.2.2v2.71zm0-6.222a.2.2 0 0 1-.2.2h-2.8a.2.2 0 0 1-.2-.2v-2.71c0-.111.09-.2.2-.2h2.8c.11 0 .2.089.2.2v2.71zm6.4 18.667a.2.2 0 0 1-.2.2h-2.8a.2.2 0 0 1-.2-.2v-2.711c0-.11.09-.2.2-.2h2.8c.11 0 .2.09.2.2v2.71zm0-6.222a.2.2 0 0 1-.2.2h-2.8a.2.2 0 0 1-.2-.2v-2.711c0-.11.09-.2.2-.2h2.8c.11 0 .2.09.2.2v2.71zm0-6.223a.2.2 0 0 1-.2.2h-2.8a.2.2 0 0 1-.2-.2v-2.71c0-.111.09-.2.2-.2h2.8c.11 0 .2.089.2.2v2.71zm0-6.222a.2.2 0 0 1-.2.2h-2.8a.2.2 0 0 1-.2-.2v-2.71c0-.111.09-.2.2-.2h2.8c.11 0 .2.089.2.2v2.71zm16 18.667a.2.2 0 0 1-.2.2H50.2a.2.2 0 0 1-.2-.2v-2.711c0-.11.09-.2.2-.2H53a.2.2 0 0 0 .2-.2v-2.711a.2.2 0 0 0-.2-.2h-2.8a.2.2 0 0 1-.2-.2v-2.711c0-.11.09-.2.2-.2H53a.2.2 0 0 0 .2-.2v-2.712a.2.2 0 0 0-.2-.2h-2.8a.2.2 0 0 1-.2-.2v-2.71c0-.111.09-.2.2-.2h12.4c.11 0 .2.089.2.2v15.155zm-3.2-12.045a.2.2 0 0 0-.2-.2h-2.8a.2.2 0 0 0-.2.2v2.712c0 .11.09.2.2.2h2.8a.2.2 0 0 0 .2-.2v-2.712zm0 6.223a.2.2 0 0 0-.2-.2h-2.8a.2.2 0 0 0-.2.2v2.71c0 .111.09.2.2.2h2.8a.2.2 0 0 0 .2-.2v-2.71z",
    fill: "#006FD5"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1201_2585",
    x: 3,
    y: 3,
    width: 92,
    height: 88,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1201_2585"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1201_2585",
    result: "shape"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFlagOrgs);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "flag-orgs.f921fba8c97e1ee9e775ca573ad216c3.svg";